import wrapper from 'wrapper';

class BackToTopBtn {
    constructor() {
        this.profileContainer = wrapper.select('.profile__section');
        this.addBackToTopBtn();
        this.backToTopBtn = wrapper.select('.back-to-top');
        this.hasBtnShown = false;

        this.backToTopBtn.addEventListener('click', (e) => {
            e.preventDefault();

            wrapper.select('.filter-buttons').scrollIntoView();
            wrapper.select('.filter-buttons__button-input.active').focus();
            wrapper.trackUserAction('button clicked', 'back to top');
        });

        wrapper.onRawScroll(() => {
            if (
                (wrapper.selectAll('.profiles').length < 9
                    && wrapper.select('.filter-buttons').getBoundingClientRect().top < 0
                )) {
                if (this.hasBtnShown) {
                    this.backToTopBtn.classList.remove('hide-btn');
                    this.backToTopBtn.removeAttribute('style');
                }
                else {
                    this.hasBtnShown = true;
                }
                this.backToTopBtn.classList.add('show-btn');
            }
            else {
                if (this.hasBtnShown) {
                    this.backToTopBtn.classList.add('hide-btn');
                }
                this.backToTopBtn.classList.remove('show-btn');
            }
        });
    }

    addBackToTopBtn() {
        const { assetsPath } = wrapper.getConfig();

        // Add spacing between button and end of profile container
        const buttonBuffer = document.createElement('div');
        buttonBuffer.classList.add('back-to-top__buffer');

        // Create the button
        const buttonEl = document.createElement('div');
        buttonEl.classList.add(
            'back-to-top',
        );
        buttonEl.innerHTML = `<a href="#filter-buttons" class="back-to-top__link">
            <img src="${assetsPath}/img/back-to-top.svg" class="back-to-top__icon" aria-hidden="true"/>
            ${__('button_text')}
        </a>`;

        this.profileContainer.append(buttonBuffer);
        this.profileContainer.append(buttonEl);
    }
}

export default BackToTopBtn;
